// extracted by mini-css-extract-plugin
export var card = "styles-module--card--09f76";
export var cardImage = "styles-module--cardImage--6eca3";
export var cards = "styles-module--cards--e00ca";
export var title = "styles-module--title--118c8";